import { Expose } from "class-transformer";

export default class ModelWarningBlockNotification {
	@Expose({name: 'isActive'})
	private _isActive: boolean | undefined = false;
	@Expose({name: 'messageRu'})
	private _messageRu: string | null | undefined = null;
	@Expose({name: 'messageEn'})
	private _messageEn: string | null | undefined = null;
	@Expose({name: 'tag'})
	private _tag: string | null | undefined = null;
	@Expose({name: 'order'})
	private _order: number | null | undefined = null;

	get isActive(): boolean | undefined {
		return this._isActive;
	}

	get messageRu(): string | null | undefined {
		return this._messageRu
	}

	get messageEn(): string | null | undefined {
		return this._messageEn;
	}

	get tag(): string | null | undefined {
		return this._tag;
	}

	get order(): number | null | undefined {
		return this._order;
	}
}
